import { v4 as uuidv4 } from 'uuid';

const correlationId = uuidv4();

export default correlationId;
